<ngx-mat-timepicker-face [color]="color"
                     [selectedTime]="selectedHour"
                     [faceTime]="hoursList"
                     (timeChange)="hourChange.next($event)"
                     (timeSelected)="onTimeSelected($event)"></ngx-mat-timepicker-face>
